import React from 'react';
import styled from 'astroturf/react';
import { LeftArrow } from 'js/social/shared/Icons';
import {
  LinkButton,
  LinkButtonProps,
} from 'js/social/shared/design_system/LinkButton';
import _Container from "BackButton-Container.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/social/shared/BackButton.tsx?styleId=Container";


const Container = /*#__PURE__*/styled(LinkButton, null, {
  displayName: "Container",
  styles: _Container
});

const BackButton: React.FC<LinkButtonProps> = ({ children, ...props }) => {
  return (
    <Container {...props}>
      <LeftArrow />
      {children}
    </Container>
  );
};

export default BackButton;
